import { Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { forwardRef } from "react"
import { Controller } from "react-hook-form"
import styled from "styled-components"

import { InputWrapper } from "areas/order/components"
import Checkbox from "components/checkbox"
import { to_currency } from "helpers/number"

const ShipMethod = styled.label`
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.grey[20]};
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 8px 12px;
`
const MethodLabels = styled.div`
  flex: 1;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.02em;
  line-height: 22px;
  padding-right: 8px;
  text-align: left;
`
const MethodDetails = styled.div`
  align-items: center;
  display: flex;
`
const MethodDate = styled.p`
  color: ${(props) => props.theme.colors.black};
  font-size: 16px;
  font-weight: 300;
  letter-spacing: -0.02em
  line-height: 22px;
  margin: 0;
`
const MethodPrice = styled.h5`
  color: ${(props) =>
    props.hasDiscount ? props.theme.colors.sale : props.theme.colors.black};
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.02em;
  line-height: 22px;
  margin: 0;
  padding-right: 14px;
  padding-top: 5px;
  strike {
    float: right;
  }
`
const UpgradedShipping = styled.h5`
  color: green;
  font-size: 16px;
  font-weight: normal;
  margin: 0;
`

const RadioInput = forwardRef(({ id, inputValue, value, ...props }, ref) => {
  return (
    <Checkbox
      checked={value === inputValue}
      id={id}
      ref={ref}
      value={inputValue}
      {...props}
    />
  )
})

RadioInput.displayName = "RadioInput"

const ShipMethods = ({ available_ship_methods, control, order }) => {
  return (
    <div>
      {available_ship_methods.map((asm) => (
        <InputWrapper key={`ship_${asm.service_type}`}>
          <ShipMethod htmlFor={`ship_${asm.service_type}`}>
            <MethodLabels>
              {asm.original_charge && asm.shipping_charge == 0 ? (
                <Typography>
                  {asm.service_label}
                  {asm.carrier_label && ` (${asm.carrier_label})`}
                  <UpgradedShipping>
                    {asm.auto_upgrade
                      ? "Your order qualifies for FREE FedEx 2Day"
                      : "Special Offer on orders $299+"}
                  </UpgradedShipping>{" "}
                </Typography>
              ) : (
                <Typography>
                  {asm.service_label}
                  {asm.carrier_label && ` (${asm.carrier_label})`}
                </Typography>
              )}
              <MethodDate>Delivers {asm.receive_date}</MethodDate>
            </MethodLabels>
            <MethodDetails>
              <MethodPrice>
                {asm.shipping_charge > asm.delta_charge && "+"}
                {to_currency(asm.delta_charge, {
                  includeVat: order.include_vat,
                  taxRate: order.tax_rate,
                })}
              </MethodPrice>
              <Controller
                control={control}
                name="ship_method_id"
                render={({ field }) => (
                  <RadioInput
                    id={`ship_${asm.service_type}`}
                    inputValue={asm.service_type}
                    name="ship_method_id"
                    {...field}
                  />
                )}
              />
            </MethodDetails>
          </ShipMethod>
        </InputWrapper>
      ))}
    </div>
  )
}

RadioInput.propTypes = {
  id: PropTypes.string,
  inputValue: PropTypes.string,
  value: PropTypes.string,
}

ShipMethods.propTypes = {
  available_ship_methods: PropTypes.array,
  control: PropTypes.object,
  order: PropTypes.object,
}

export default ShipMethods
